module.exports = __webpack_public_path__ + "static/1-4a676c0a57ee8d25403630d2a88647b6.jpg";